webpackJsonp([100208985622591],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "div",
	        { className: _pageModule2.default.container },
	        _react2.default.createElement(_SEO2.default, { title: "Patreon | A-Town FM" }),
	        _react2.default.createElement(
	            "h1",
	            null,
	            "Patreon"
	        ),
	        _react2.default.createElement(
	            "a",
	            { className: _pageModule2.default.patreonButton, href: "https://www.patreon.com/bePatron?u=7182685&redirect_uri=http%3A%2F%2Fatownfm.com%2Fpatreon&utm_medium=widget" },
	            "BECOME A PATRON"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "With your support we will be able to bring on better guests, improve quality, expand, and do more for our fans. Any support whether financially or by word of mouth is appreciated!"
	        ),
	        _react2.default.createElement(
	            "h1",
	            null,
	            "Wall of Thanks"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	            "table",
	            { "class": "thanks" },
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    "Patron"
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    "Patron Corner Episode"
	                )
	            ),
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    "Nicholas Lewis"
	                ),
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/episodes/39:_Nick_s_Corner/" },
	                        "#39 - Nick's Corner"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    "Chad S"
	                ),
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/episodes/41:_Tolkien_Corner,_British_Royalty,_Chad_s_Corner/" },
	                        "#41 - Tolkien Corner, British Royalty, Chad's Corner"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    "Dani W"
	                ),
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/episodes/51:_Dani_Corner/" },
	                        "#51 - Dani Corner"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    "Ben Maga"
	                ),
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                        "em",
	                        null,
	                        "Coming Soon..."
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    "Nick P."
	                ),
	                _react2.default.createElement("td", null)
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-patreon-js-bf3a7e8e54ec11098267.js